<template>
  <div>
    <div class="kit__utils__heading">
      <h5><span class="mr-3">{{this.$route.meta.title}}</span></h5>
    </div>
    <div class="card">
      <div class="card-header card-header-flex">
        <div class="d-flex flex-column justify-content-center mr-auto">
          <h5 class="mb-0"></h5>
        </div>
      </div>
      <div class="card-body">
        <div class="card-header card-header-flex">
          <div class="d-flex flex-column justify-content-center mr-auto">
            <h5 class="mb-0"></h5>
          </div>
          <div class="d-flex flex-column justify-content-center">
            <a class="btn btn-primary" href="javascript: void(0);" @click="refreshData()"><i
                class="fe fe-rotate-cw mr-1" /> รีเฟรช</a>
          </div>
        </div>
        <a-table :columns="columns" :dataSource="data" rowKey='id' :scroll="{ x: 1500 }"
        :pagination="{defaultPageSize: 10, pageSizeOptions: ['10', '20', '30', '40', '50', '100'], showSizeChanger : true }">
          <h6 slot="firstname" slot-scope="text , record" style="color:#595c97">
              {{text}} {{record.lastname}}
          </h6>
          <h6 slot="BanOperatorStatus" slot-scope="text , record">
            <b-badge :variant="getStatus('banOperator',text).color" pill href="#" @click="useAction(record.id,text)">
              {{getStatus('banOperator',text).name}}
            </b-badge>
             <b-badge :variant="getStatusRePass('rePassword',record.rePassword).color" :hidden="getStatusHide(record.rePassword)">
              {{getStatusRePass('rePassword',record.rePassword).name}}
            </b-badge>
          </h6>
          <span slot="Action" slot-scope="text,record">
            <b-dropdown variant="Clear" text="จัดการ" class="mb-3 mr-2">
              <b-dropdown-item @click="rePassword(record.id)">รีเซตรหัสผ่าน</b-dropdown-item>
            </b-dropdown>
          </span>
        </a-table>
      </div>
    </div>
  </div>
</template>
<script>

import { getName } from '@/utils/status'
import apiClient from '@/services/api'
import moment from 'moment'
import Swal from 'sweetalert2'
const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  },
})
export default {
  data() {
    return {
      data: [],
      columns: [
        {
          title: 'ลำดับ',
          key: 'OperatorId',
          dataIndex: 'id',
        },
        {
          title: 'คู่ค้า',
          key: 'operatorMainName',
          dataIndex: 'operatorMainName',
          filters: [],
          onFilter: (value, record) => record.operatorMainName.toLowerCase().includes(value.toLowerCase()),
        },
        {
          title: 'username',
          key: 'username',
          dataIndex: 'username',
        },
        {
          title: 'defaultPassword',
          key: 'defaultPassword',
          dataIndex: 'defaultPassword',
        },
        {
          title: 'name',
          key: 'Name',
          dataIndex: 'firstname',
          scopedSlots: { customRender: 'firstname' },
        },
        {
          title: 'สถานะ',
          key: 'BanOperatorStatus',
          dataIndex: 'banOperator',
          scopedSlots: { customRender: 'BanOperatorStatus' },
        },
        {
          title: 'สร้างเมื่อ',
          key: 'createdAt',
          dataIndex: 'createdAt',
          customRender: (text, row, index) => {
            return moment(text).format('DD/MM/YYYY HH:mm:ss')
          },
        },
        {
          title: 'ตัวเลือก',
          key: 'Action',
          dataIndex: 'operatorId',
          scopedSlots: { customRender: 'Action' },
        },
      ],
    }
  },
  methods: {
    async getOperatorAdmin() {
      // console.log(this.$route);
      await apiClient.get(`/operator/getData/${this.$route.params.OperatorId}`).then(response => {
        if (response.data.code === '000') {
          this.data = response.data.responseData.data
          if (this.data.length > 0) {
            const listOperater = this.data.map(function(item, pos) {
              return { text: item.operatorMainName, value: item.operatorMainName }
            })
            this.columns[1].filters = [
              ...new Map(listOperater.map((item) => [item.text, item])).values(),
            ]
          }
        }
      }).catch(error => {
        Swal.showValidationMessage(
          `เกิดข้อผิดพลาด: ${error.message}`,
        )
      })
    },
    getStatus(type, status) {
      return getName(type, status)[0]
    },
    getStatusRePass(type, status) {
      return getName(type, status)[0]
    },
    getStatusHide(status) {
      let result = false
      if (status === 0) { result = false } else { result = true }
      return result
    },
    useAction(OperatorId, status) {
      if (status === 1) this.updateOperatorStatus(OperatorId, 'openStatus')
      if (status === 0) this.updateOperatorStatus(OperatorId, 'blockStatus')
    },
    async updateOperatorStatus(OperatorId, type) {
      const BanOperator = (type === 'openStatus') ? 0 : (type === 'blockStatus') ? 1 : null
      const title = (type === 'openStatus') ? 'คุณแน่ใจหรือไม่ที่ต้องการเปิดใช้งาน' : (type === 'blockStatus') ? 'คุณแน่ใจหรือไม่ที่ต้องการปิดการใช้งาน' : null

      if (BanOperator !== '') {
        await Swal.fire({
          title: title,
          icon: 'question',
          confirmButtonText: 'ยืนยัน',
          cancelButtonText: 'ยกเลิก',
          showCancelButton: true,
          showCloseButton: true,
          showLoaderOnConfirm: true,
          preConfirm: (value) => {
            if (value) {
              const data = {
                BanOperator,
              }
              return apiClient.put(`/operator/updateStatus/${OperatorId}`, data).then(response => {
                if (response.status !== 200) {
                  throw new Error(response.message)
                }
                return response.data
              }).catch(error => {
                Swal.showValidationMessage(
                  `Request failed: ${error}`,
                )
              })
            }
          },
          allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
          if (result.isConfirmed) {
            const iconError = (result.value.code === '000') ? 'success' : 'error'
            Toast.fire({
              icon: iconError,
              title: result.value.message,
            })
            this.getOperatorAdmin()
          }
        })
      }
    },
    rePassword(id) {
      if (id !== null) this.OperatorRePassword(id)
    },
    async OperatorRePassword(id) {
      const title = 'คุณแน่ใจหรือไม่ที่ต้องการรีเซตรหัสผ่าน'

      if (id !== '') {
        await Swal.fire({
          title: title,
          icon: 'question',
          confirmButtonText: 'ยืนยัน',
          cancelButtonText: 'ยกเลิก',
          showCancelButton: true,
          showCloseButton: true,
          showLoaderOnConfirm: true,
          preConfirm: (value) => {
            if (value) {
              return apiClient.put(`/operator/rePassword/${id}`).then(response => {
                if (response.status !== 200) {
                  throw new Error(response.message)
                }
                return response.data
              }).catch(error => {
                Swal.showValidationMessage(
                  `Request failed: ${error}`,
                )
              })
            }
          },
          allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
          if (result.isConfirmed) {
            const iconError = (result.value.code === '000') ? 'success' : 'error'
            Toast.fire({
              icon: iconError,
              title: result.value.message,
            })
            this.getOperatorAdmin()
          }
        })
      }
    },
    refreshData() {
      this.loading(true)
      this.getOperatorAdmin()
      this.loading(false)
    },
    async loading(e) {
      if (e) {
        Swal.fire({
          title: 'กำลังตรวจสอบ',
          text: 'ระบบกำลังตรวจสอบข้อมูล กรุณารอสักครู่.',
          showConfirmButton: false,
          allowOutsideClick: false,
          onBeforeOpen: () => {
            Swal.showLoading()
          },
        })
      } else {
        Swal.close()
      }
    },
  },
  async created() {
    await this.getOperatorAdmin()
  },

}
</script>

<style>

</style>
